module.exports = __webpack_public_path__ + "img/w1_3.db55c79d.png";